<template>
  <div class="add-engine">
    <div class="d-flex justify-content-between align-items-center">
      <h2 class="title">Add Engine</h2>
      <div class="ico" @click="$emit('close-me')">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
            fill="#474D52"
          />
        </svg>
      </div>
    </div>
    <button
      class="btn btn-primary btn-sm collapsed"
      @click="$emit('show-add-new')"
    >
      +Add New Engine
    </button>
    <h1>Your current engine</h1>
    <div
      class="engine"
      v-for="(engine, i) in engines"
      :key="i"
      v-b-tooltip.hover
      title="Edit Engine"
      @click="$emit('show-edit-engine', engine, i)"
    >
      <div class="engine-detail">
        <h3 class="engine-title">
          {{ engine.text }}
        </h3>
        <h6 class="time">at {{ engine.time }}</h6>
        <div class="weeks">
          <div class="week" v-for="(repeat, k) in engine.when" :key="k">
            {{ repeat }}
          </div>
        </div>
      </div>
      <div class="icon">
        <span class="ico">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.52827 3.52859C5.78862 3.26824 6.21073 3.26824 6.47108 3.52859L10.4711 7.52859C10.7314 7.78894 10.7314 8.21105 10.4711 8.4714L6.47108 12.4714C6.21073 12.7317 5.78862 12.7317 5.52827 12.4714C5.26792 12.2111 5.26792 11.7889 5.52827 11.5286L9.05687 8L5.52827 4.4714C5.26792 4.21105 5.26792 3.78894 5.52827 3.52859Z"
              fill="#557EFB"
            />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    engines: Array
  },
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
.add-engine {
  padding: 24px;
  position: relative;
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
    margin: 0;
  }
}

.btn.collapsed {
  padding: 11px;
  width: 100%;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  border-radius: 8px;
  margin-top: 23px;
}

h1 {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
  color: #8d99a0;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 24px;
}
.engine {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // width: 280px;
  height: 102px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
}
.engine .engine-detail {
  margin-left: 16px;
}
.engine .engine-title {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
}
.engine .time {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #8d99a0;
  margin-top: 4px;
  // margin-bottom: 7px;
}
.weeks {
  display: flex;
  // justify-content: space-around;
  align-items: center;
}
.weeks .week {
  border-radius: 50%;

  width: 24px;
  height: 24px;
  margin: 8px 0px;
  text-align: center;
  line-height: 24px;
  background-color: red;
  color: #557efb;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  background-color: rgba(85, 126, 251, 0.1);
  margin-right: 8px;
}
.engine .icon {
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
